import React, { useCallback, useEffect, useState } from 'react';
import { adminService, squareService } from '../../services';
import { useUser } from '../../context/UserContext';
import { useDialog } from '../../context/DialogContext';
import { AdminPageHeader, DataTable, SearchField, shortDate } from '../../components/admin/shell';

/** SYSTEM › CITY PORTALS — spec/sections.md §25. One row per square; REGENERATE BANNER is `squares` · edit. */
export default function SquaresPage() {
  const { can } = useUser();
  const { showAlert } = useDialog();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await adminService.getSquares({ q });
    setLoading(false);
    if (r.success) { setRows(r.data.squares || []); setTotal(r.data.total || 0); }
  }, [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  const regenerate = async (s) => {
    setBusy(s.id);
    const r = await squareService.regenerateBanner(s.citySlug);
    setBusy(null);
    if (!r.success) await showAlert({ title: 'COULD NOT REGENERATE', message: r.error, type: 'error', theme: 'admin' });
    load();
  };

  return (
    <>
      <AdminPageHeader section="squares" meta="One row per City Portal. Regenerate a banner when the city's look has gone stale." />
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchField value={q} onChange={setQ} placeholder="SEARCH SQUARES" />
        </div>
        <DataTable
          columns={[
            { key: 'cityLabel', label: 'CITY', fr: 2 },
            { key: 'citySlug', label: 'SLUG', fr: 1.6 },
            { key: 'memberCount', label: 'MEMBERS', fr: 1, right: true, render: (s) => (s.memberCount ?? 0).toLocaleString() },
            { key: 'bannerState', label: 'BANNER', fr: 1, render: (s) => String(s.bannerState || 'none').toUpperCase() },
            { key: 'bannerFetchedAt', label: 'REGENERATED', fr: 1, render: (s) => shortDate(s.bannerFetchedAt) },
            { key: 'isActive', label: 'STATUS', fr: 0.9, render: (s) => (s.isActive ? 'LIVE' : 'OFF') },
          ]}
          rows={rows}
          loading={loading}
          hasActions={can('squares', 'edit')}
          actions={(s) => [{ label: busy === s.id ? 'REGENERATING…' : 'REGENERATE BANNER', onClick: () => busy ? null : regenerate(s) }]}
          footerLeft={`${total.toLocaleString()} squares`}
        />
      </div>
    </>
  );
}
